import React from 'react'
import { getVideo } from 'Utils/videoUrls'
import DOMPurify from 'dompurify'

interface VideoProps {
  videos?: any
}

const Videos = ({ videos }: VideoProps) => {
  return (
    <>
      {videos.map((video: any) => (
        <div
          key={video.id || video.hotspotMediaId}
          tabIndex={0}
          aria-label={video.title}
        >
          <h3>{video.title}</h3>
          <div>{getVideo(video)}</div>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(video.description, {
                ADD_ATTR: ['target'],
              }),
            }}
          />
        </div>
      ))}
    </>
  )
}

export default Videos
